import type BaseError from './BaseError';

type InputError = {
  message: string;
  locations: {
    line: string;
    column: string;
  }[];
  extensions: {
    code: 'BAD_USER_INPUT';
    stacktrace: unknown[];
  };
};
export default class BaseUserInputError implements BaseError {
  readonly message = 'Form data error';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(e: InputError) {
    //
  }
}
